import { useContext, useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import * as Layouts from "./Layouts";
import { UserContext } from "./context";
import { initApp, showSpinner } from "./handlers";
import {
  Login,
  Management,
  ManagementActividad,
  ManagementPermisos,
  ManagementRoles,
  ManagementRolesPermisos,
  ManagementUsuarios,
  Menu,
} from "./screens";
import { Solicitud } from "./screens/Rifa/Solicitud";
import { Pago } from "./screens/Pago/Pago";
import Error from "./screens/Error";
import NoDisponible from "./screens/NoDisponible";
import AccesoDenegadoMuni from "./screens/AccesoDenegadoMuni";
import BackOffice from "./screens/Admin/BackOffice/BackOffice";



const App = () => {
  const { actions, loading } = useContext(UserContext);

  useEffect(() => {
    initApp(actions);
  }, []);

  showSpinner(loading);

  const NotFound = () => 404;

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Solicitud />} />
        {/* <Route path="/backoffice" element={<BackOffice />} /> */}
        
        <Route path="/pago" element={<Pago />} />
        {/* <Route element={<Layouts.UserLayout />}> */}

        <Route element={<Management />} path="/administrador/roles-permisos" />
        <Route element={<ManagementRoles />} path="/administrador/roles-permisos/roles" />
        <Route element={<ManagementPermisos />} path="/administrador/roles-permisos/permisos" />
        <Route
          element={<ManagementRolesPermisos />}
          path="/administrador/roles-permisos/role-permisos"
        />
        <Route element={<ManagementActividad />} path="/administrador/activity-log" />
        <Route element={<ManagementUsuarios />} path="/administrador/roles-permisos/usuarios" />

        <Route path="/no_disponible" element={<NoDisponible />} />
        <Route path='/acceso_denegado_muni' element={<AccesoDenegadoMuni />} />
        <Route path="*" element={<Error />} />
        {/* </Route> */}
        {/* <Route path="/login" element={<Login />} /> */}
      </Routes>
    </HashRouter>
  );
};

export default App;
